var map = {
	"./BioMatrix.vue": 54591,
	"./DailyInvite.vue": 35982,
	"./activity.vue": 25191,
	"./airdrop-bak.vue": 43642,
	"./airdrop.vue": 72673,
	"./airdropReward.vue": 75723,
	"./bitgetWallet.vue": 18127,
	"./bitgetWalletAirdrop.vue": 15697,
	"./boost.vue": 13415,
	"./code.vue": 30964,
	"./earn.vue": 96829,
	"./frens.vue": 69607,
	"./index.vue": 81088,
	"./join.vue": 5756,
	"./lottery.vue": 57671,
	"./lotteryDetail.vue": 47515,
	"./lucky.vue": 88129,
	"./luckyCode.vue": 88819,
	"./mine.vue": 93414,
	"./okxWallet.vue": 88630,
	"./pph.vue": 61838,
	"./rank.vue": 91745,
	"./sign.vue": 26446,
	"./spin.vue": 63374,
	"./squad.vue": 4436,
	"./taskDetail.vue": 8313,
	"./user.vue": 18020,
	"./wallet.vue": 72112,
	"./withdraw.vue": 96938,
	"./youtube.vue": 91721
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45535;